module.exports = __webpack_public_path__ + "img/ipad-hero_cn.e95432e.jpg";